import { tw } from "@careinfo/tailwind";
import { EditorContent, useEditorState } from "@tiptap/react";
import { useRef } from "react";
import ImageBlockMenu from "../../extensions/ImageBlock/components/ImageBlockMenu";
import { ColumnsMenu } from "../../extensions/MultiColumn/menus";
import { TableColumnMenu, TableRowMenu } from "../../extensions/Table/menus";
import { useBlockEditor } from "../../hooks/useBlockEditor";
import { LinkMenu } from "../menus";
import { TextMenu } from "../menus/TextMenu";

export const BlockEditor = ({
  onChange,
  content,
  setTableOfContent = null,
}) => {
  const menuContainerRef = useRef(null);

  const { editor } = useBlockEditor({ onChange, content, setTableOfContent });

  const { characters, words } = useEditorState({
    editor,
    selector: (ctx): { characters: number; words: number } => {
      const { characters, words } = ctx.editor?.storage.characterCount || {
        characters: () => 0,
        words: () => 0,
      };
      return { characters: characters(), words: words() };
    },
  });

  if (!editor) {
    return null;
  }

  return (
    <div className={tw`flex w-full h-full`} ref={menuContainerRef}>
      <div className={tw`flex w-full flex-col flex-1 h-full overflow-hidden`}>
        {/* <EditorInfo characters={characters} words={words} /> */}
        <div>
          <EditorContent
            editor={editor}
            className={tw`flex-1 overflow-y-auto  p-1  border border-gray-400`}
          />
        </div>
        <LinkMenu editor={editor} appendTo={menuContainerRef} />
        <TextMenu editor={editor} />
        <ColumnsMenu editor={editor} appendTo={menuContainerRef} />
        <TableRowMenu editor={editor} appendTo={menuContainerRef} />
        <TableColumnMenu editor={editor} appendTo={menuContainerRef} />
        <ImageBlockMenu editor={editor} appendTo={menuContainerRef} />
      </div>
    </div>
  );
};

export default BlockEditor;
